if (!customElements.get('siamaya-shop')) {
  customElements.define('siamaya-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.grid = this.querySelector('[data-shop-grid]');
      this.cards = Array.from(this.querySelectorAll('[data-shop-card]'));
      this.flavors = Array.from(this.querySelectorAll('[data-shop-flavor]'));
      this.sugar = this.querySelector('[data-shop-sugar]');
      this.sort = this.querySelector('[data-shop-sort]');
      this.count = this.querySelector('[data-shop-count]');
      this.clear = this.querySelector('[data-shop-clear]');
      this.empty = this.querySelector('[data-shop-empty]');
      this.querySelector('[data-shop-controls]').hidden = false;
      const group = this.querySelector('[data-shop-flavors]');
      if (group) group.hidden = false;
      this.flavors.forEach(button => button.addEventListener('click', () => {
        this.state.flavor = button.dataset.shopFlavor;
        this.update(true);
      }));
      this.sugar?.addEventListener('change', () => {
        this.state.sugar = this.sugar.checked;
        this.update(true);
      });
      this.sort.addEventListener('change', () => {
        this.state.sort = this.sort.value;
        this.update(true);
      });
      this.querySelectorAll('[data-shop-clear], [data-shop-reset]').forEach(button => button.addEventListener('click', () => {
        this.state.flavor = 'all';
        this.state.sugar = false;
        this.update(true);
      }));
      this.onPopState = () => this.readState();
      window.addEventListener('popstate', this.onPopState);
      this.readState();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
      this.initialized = false;
    }

    readState() {
      const params = new URL(window.location.href).searchParams;
      const flavor = params.get('flavor');
      const sort = params.get('shop_sort');
      this.state = {
        flavor: this.flavors.some(button => button.dataset.shopFlavor === flavor) ? flavor : 'all',
        sugar: Boolean(this.sugar) && params.get('no_added_sugar') === '1',
        sort: Array.from(this.sort.options).some(option => option.value === sort) ? sort : 'title-ascending'
      };
      this.update(false);
    }

    update(pushHistory) {
      const { flavor, sugar, sort } = this.state;
      const ordered = [...this.cards].sort((a, b) => {
        const nameOrder = a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price) || nameOrder;
        if (sort === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price) || nameOrder;
        return nameOrder;
      });
      let visible = 0;
      const reorder = this.appliedSort !== sort;
      ordered.forEach(card => {
        card.hidden = (flavor !== 'all' && !card.dataset.flavors.split(' ').includes(flavor)) || (sugar && card.dataset.noSugar !== 'true');
        if (!card.hidden) visible++;
        if (reorder) this.grid.append(card);
      });
      this.appliedSort = sort;
      this.flavors.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shopFlavor === flavor)));
      if (this.sugar) this.sugar.checked = sugar;
      this.sort.value = sort;
      this.count.textContent = visible === 1 ? this.count.dataset.one : this.count.dataset.many.replace('999', String(visible));
      this.clear.hidden = flavor === 'all' && !sugar;
      this.empty.hidden = visible > 0;
      if (pushHistory) {
        const url = new URL(window.location.href);
        const set = (key, value) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key);
        set('flavor', flavor === 'all' ? '' : flavor);
        set('no_added_sugar', sugar ? '1' : '');
        set('shop_sort', sort === 'title-ascending' ? '' : sort);
        window.history.pushState({}, '', url);
      }
    }
  });
}

